// import { camelCase, snakeCase } from 'change-case'

/**
 * 텍스트 복사
 * @param value
 */
export const textCopy = (value) => {
  const el = document.createElement('textArea')
  document.body.appendChild(el)
  el.value = value
  el.select()
  document.execCommand('Copy')
  el.remove()
}

export const jsLoad = async (attr) => {
  return new Promise((resolve, reject) => {
    const org = document.getElementById(attr.id)
    if (org) {
      resolve(org)
      return
    }
    const sc = document.createElement('script')
    for (const key in attr) {
      sc[key] = attr[key]
    }

    sc.onload = () => {
      resolve(sc)
    }
    sc.onerror = () => {
      reject(new Error('script load error'))
    }

    document.head.appendChild(sc)
  })
}

export const cssLoad = (attr) => {
  return new Promise((resolve, reject) => {
    const org = document.getElementById(attr.id)
    if (org) {
      resolve(org)
      return
    }
    const sc = document.createElement('link')
    sc.rel = 'stylesheet'
    sc.type = 'text/css'

    for (const key in attr) {
      sc[key] = attr[key]
    }

    sc.onload = () => {
      resolve(sc)
    }
    sc.onerror = () => {
      reject(new Error('script load error'))
    }

    document.head.appendChild(sc)
  })
}

export const simpleClone = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}

export const sleep = (m) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(m)
    }, m)
  })
}

export const uuid = () => {
  function s4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

export const getRedirectUri = (to) => {
  let uri
  if (to) {
    uri = to.fullPath
  } else {
    uri = location.pathname + location.search
  }
  return uri
}

export const toCamel = (str) => {
  let temp = str
  temp = temp.replace(/_[a-z]/g, (s) => {
    s = s.replace('_', '')
    s = s.toUpperCase()
    return s
  })

  return temp
}

export function commaFormat(value) {
  if (!value) return '0'
  const strNumber = value.toString().replace(/[^\d\\-]/g, '')
  const plainNumber = Number(strNumber).toString()
  return plainNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function checkName(name) {
  //name의 마지막 음절의 유니코드(UTF-16)
  const charCode = name.charCodeAt(name.length - 1)

  //유니코드의 한글 범위 내에서 해당 코드의 받침 확인
  const consonantCode = (charCode - 44032) % 28

  if (consonantCode === 0) {
    //0이면 받침 없음 -> 를
    return `${name}를`
  }
  //1이상이면 받침 있음 -> 을
  return `${name}을`
}

// export const camelCaseKeys = (v) => {
//   if (Array.isArray(v)) {
//     for (let i = 0; i < v.length; i++) {
//       v[i] = camelCaseKeys(v[i])
//     }
//     return v
//   }
//   if (typeof v === 'object') {
//     const o = {}
//     for (const k in v) {
//       o[camelCase(k)] = v[k]
//     }
//     for (const k in o) {
//       if (o[k] && typeof o[k] === 'object') {
//         o[k] = camelCaseKeys(o[k])
//       }
//     }
//     return o
//   }
//   return v
// }

// export const snakeCaseKeys = (v) => {
//   if (Array.isArray(v)) {
//     for (let i = 0; i < v.length; i++) {
//       v[i] = snakeCaseKeys(v[i])
//     }
//     return v
//   } else if (typeof v === 'object') {
//     const o = {}
//     for (const k in v) {
//       o[snakeCase(k)] = v[k]
//     }
//     for (const k in o) {
//       if (o[k] && typeof o[k] === 'object') {
//         o[k] = snakeCaseKeys(o[k])
//       }
//     }
//     return o
//   }
//   return v
// }

export default {
  textCopy,
  simpleClone,
  cssLoad,
  jsLoad,
  sleep,
  uuid,
  getRedirectUri,
  // camelCaseKeys,
  // snakeCaseKeys,
  // camelCase,
  // snakeCase,
}
